var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Chess-Figures--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Chess Figures Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.19 9.9a0.25 0.25 0 0 1 0.24 0.16 0.25 0.25 0 0 1 -0.07 0.27 14.63 14.63 0 0 0 -1.43 1.48c-0.8 1.1 -1.65 1.84 -1.73 5.21a0.47 0.47 0 0 0 0.14 0.36 0.48 0.48 0 0 0 0.36 0.15h7.21a0.49 0.49 0 0 0 0.5 -0.49c0.05 -12.27 1.78 -11.6 -2 -13.51 -0.78 -0.38 -2 -1 -2.88 -1.49a0.64 0.64 0 0 0 -0.63 0 0.63 0.63 0 0 0 -0.31 0.54V3.7a1 1 0 0 1 -0.37 0.77L0.66 7.35A1.3 1.3 0 0 0 0 8.63c0.29 0.81 0.44 1.27 1.29 1.27Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.08 19.53c-0.15 -0.4 -0.63 -0.5 -1.1 -0.5H2.31c-0.47 0 -0.94 0.1 -1.09 0.5L0.8 21.44a0.48 0.48 0 0 0 0.11 0.41 0.57 0.57 0 0 0 0.43 0.18H11a0.54 0.54 0 0 0 0.42 -0.18 0.42 0.42 0 0 0 0.11 -0.41Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 21.44 -0.42 -1.91c-0.15 -0.4 -0.62 -0.5 -1.09 -0.5h-7.68c-0.48 0 -1 0.1 -1.1 0.5l-0.42 1.91a0.45 0.45 0 0 0 0.12 0.41 0.54 0.54 0 0 0 0.42 0.18h9.62a0.57 0.57 0 0 0 0.43 -0.18 0.48 0.48 0 0 0 0.12 -0.41Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 17.53h6.65a0.51 0.51 0 0 0 0.36 -0.15 0.55 0.55 0 0 0 0.14 -0.37 15.5 15.5 0 0 0 -1.85 -6.58 1.09 1.09 0 0 0 -1 -0.57h-2a1.09 1.09 0 0 0 -1 0.57A15.53 15.53 0 0 0 14.7 17a0.47 0.47 0 0 0 0.14 0.37 0.48 0.48 0 0 0 0.36 0.16Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.59 5.86a2.91 2.91 0 1 0 5.82 0 2.91 2.91 0 1 0 -5.82 0",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChess);
export default ForwardRef;